import skill1 from "../../assets/webp/skills/skill (1).svg"
import skill2 from "../../assets/webp/skills/skill (2).svg"
import skill3 from "../../assets/webp/skills/skill (3).svg"
import skill4 from "../../assets/webp/skills/skill (4).svg"

export const skills = {
   skill1,
   skill2,
   skill3,
   skill4,
}

export const assets = skill => skills[skill]
